import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import { connect } from 'react-redux';
import Link from '../../components/Link';
import history from '../../history';
import Graph from './Graph';
import style from './Landing.css';

const mapStateToProps = state => ({
  userRole: state.auth.user.role_id
});

class Landing extends React.Component {
  componentDidMount() {
    // redirect to /home after 10s
    this.timer = setTimeout(() => history.push('/app'), 10000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    return (
      <Link to='/app'>
        <div className={style.landingText}>
          <h2>Engaging Learners, Constructing Education</h2>
          <div>This app is a compilation of activities and ideas found from child care teachers, resource books,
            and online sources.</div>
        </div>
        <div>
          <svg viewBox='0 0 1000 500' preserveAspectRatio='xMaxYMax meet'>
            <Graph />
          </svg>
        </div>
      </Link>
    );
  }
}

export default connect(mapStateToProps, null)(withStyles(style)(Landing));



// WEBPACK FOOTER //
// ./src/routes/landing/Landing.js